import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum, ISelectOption } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useApplyModel } from "../applyModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IApplySearch, IApplyParams, IApplyDetail, IApplyInsert, IApplyUpdata, IApplyDisable } from "../applyTypes"
import { setTitle, filterArrId, Optios, loadDictParam } from "../../../../utils/utils"
import { DictEnum } from "../../../../types/MdmDIctEnum";

const ApplyDetail = () => {
    const [form] = Form.useForm();
    const { mdmBranch, dict } = useMdmModel();
    const { selectedNavId, getSelectedNavState, replaceNav } = useNavModel()
    const { addParam, selectedRow, setAddParam, setSelectedRow, updataAddParam, updataEditParam, insertDetail, updataDetail } = useApplyModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { pageParams: { mode, id: ids } } = modes

    //应用类型
    const [appTypeDs, setAppTypeDs] = useState(loadDictParam(DictEnum.APP_TYPE, dict));

    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow[0])
        }
    }, [addParam, selectedRow[0]])

    const onFinish = (values: IApplyInsert | IApplyUpdata) => {
        if (mode == DetailType.add) {
            insertDetail(values as IApplyInsert).then(res => res && close())
        } else if (mode == DetailType.edit) {
            updataDetail(values as IApplyDetail).then(res => res && close())
        }
    }
    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-8-1")
    //         const findEdit = findNav("2-8-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])

    const close = () => {
        replaceNav(selectedNavId, "2-8")
    }

    //应用类型
    const appTypeChange = (value: string, option: ISelectOption) => {
        // option && form.setFieldsValue({ typeName: option.label });
        option && (mode == DetailType.add ? updataAddParam : updataEditParam)({ typeName: option.label, typeCode: value })
    }

    // //图片变更缓存保留  保留缓存及回显表单
    const onSetFieldsValue = (formValues: { [key: string]: any }, isFormItem: boolean = true) => {
        (mode == DetailType.add ? updataAddParam({ ...addParam, ...formValues }) : updataEditParam({ ...selectedRow[0], ...formValues }))
        isFormItem && form.setFieldsValue(formValues);
    }

    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "应用编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "应用名称",
            labelCol: { span: 6 },
            fieldName: "name",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "应用地址",
            labelCol: { span: 6 },
            fieldName: "address",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "应用类型",
            labelCol: { span: 6 },
            fieldName: "typeCode",
            options: appTypeDs,
            onSelectChange: appTypeChange,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "备注",
            labelCol: { span: 6 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },
        {
            type: FormItemTypeEnum.FileImage,
            fieldLabel: "商品图片",
            fieldName: "appUrl",
            colClassName: "file-image-box ant-col-h-auto",
            span: 24,
            isUpload: (mode == DetailType.add ? addParam?.appUrl?.length : selectedRow?.[0]?.appUrl?.length),
            md5List: mode == DetailType.add ? addParam.appUrl ?? [] : selectedRow?.[0]?.appUrl ?? [],
            onSetFieldsValue
        },
        //带出字段
        {
            type: FormItemTypeEnum.Input,
            fieldLabel: "应用类型名称",
            fieldName: "typeName",
            hidden: true
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}应用</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default ApplyDetail